<script lang="ts">
	import CopyToClipboardButton from '$lib/components/CopyToClipboardButton.svelte';
	import DefaultContentContainer from '$lib/components/DefaultContentContainer.svelte';
	import img404 from './404.jpg';
	import type { CmsErrorExtraInfoRecord } from '$lib/data/types';
	import { _, locale } from 'svelte-i18n';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { slide } from 'svelte/transition';

	let extraInfo: CmsErrorExtraInfoRecord | undefined;

	onMount(() => {
		if (!$page.error?.errorCode) return;

		if ($page.status >= 500) {
			fetch(`/${$locale}/api/errors/${$page.error.errorCode}`)
				.then((res) => {
					if (res.ok) {
						return res.json();
					}
				})
				.then((data) => {
					extraInfo = data as CmsErrorExtraInfoRecord;
				});
		}
	});
</script>

<svelte:head>
	<title>{$_('pages.error.title')} {$page.status} &mdash; {$_('page.title')}</title>
</svelte:head>

<DefaultContentContainer>
	<hgroup>
		<h1>{$_('pages.error.title')} {$page.status}</h1>

		{#if $page.error}
			<h2 lang="en">{$page.error?.message}</h2>
		{/if}
	</hgroup>

	{#if $page.status === 404}
		<img src={img404} alt="Error {$page.status}" width="1920" height="877" />
	{:else}
		<p>{$_('pages.error.genericMessage')}</p>
	{/if}

	<p class="cta">
		<a href="/{$locale}/" class="btn btn-outline" data-sveltekit-reload>
			{$_('pages.error.backToHomeText')}
		</a>
	</p>

	{#if extraInfo}
		{@const translation = getCmsTranslationForLocale(extraInfo.translations, $locale)}
		<div class="extra-help" in:slide>
			<h3>{translation.title}</h3>
			{@html translation.body}
		</div>
	{/if}

	{#if $page.error?.traceId}
		<p>{$_('pages.error.traceIdMessage')}</p>
		<div class="trace-id">
			<h4>{$_('pages.error.traceIdLabel')}</h4>
			<code>{$page.error.traceId}</code>

			<CopyToClipboardButton contents="{$_('pages.error.traceIdLabel')}: {$page.error.traceId}" />
		</div>
	{/if}
</DefaultContentContainer>

<style>
	p {
		margin-top: 1rem;
	}

	img {
		width: 100%;
		height: auto;
		margin-bottom: 1rem;
	}

	.extra-help {
		margin: 2rem 0;
	}

	.cta {
		margin: 2rem 0;
		text-align: center;
	}

	.trace-id {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
	}

	h2,
	h3,
	h4 {
		margin-top: 2rem;
		margin-bottom: 0;
	}
</style>
